import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Alert, Spinner, Text } from "@chakra-ui/react";

interface StripeElementsWrapperProps {
  stripePublishableKey: (() => Promise<string>) | string;
}

export const StripeElementsWrapper: React.FC<StripeElementsWrapperProps> = ({
  stripePublishableKey,
  children,
}) => {
  const [key, setKey] = useState(
    typeof stripePublishableKey === "string" ? stripePublishableKey : undefined
  );
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (typeof stripePublishableKey !== "string") {
      stripePublishableKey()
        .then((result) => {
          setKey(result);
        })
        .catch((error) => {
          setError(`Error initiating stripe: ${error.message}`);
        });
    }
  }, [stripePublishableKey]);

  if (error) {
    return (
      <Alert statusIcon={"error"}>
        <Text>{error}</Text>
      </Alert>
    );
  }

  if (!key) {
    return <Spinner />;
  }

  return (
    <StripeStringComponent stripePublishableKey={key}>
      {children}
    </StripeStringComponent>
  );
};

const StripeStringComponent: React.FC<{ stripePublishableKey: string }> = (
  props
) => {
  const stripePromise = loadStripe(props.stripePublishableKey);
  return <Elements stripe={stripePromise}>{props.children}</Elements>;
};
